import { render, staticRenderFns } from "./ForgottenPasswordRequestModal.vue?vue&type=template&id=281a9b3f&"
import script from "./ForgottenPasswordRequestModal.vue?vue&type=script&lang=js&"
export * from "./ForgottenPasswordRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports